import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { I18nService } from '../services/i18n.service';

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  private sub?: Subscription;
  private lastKey = '';
  private lastValue = '';

  constructor(private i18n: I18nService, private cdr: ChangeDetectorRef) {
    this.sub = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  transform(key: string, fallback = ''): string {
    if (key !== this.lastKey) {
      this.lastKey = key;
      this.lastValue = this.i18n.t(key, fallback);
      return this.lastValue;
    }
    this.lastValue = this.i18n.t(key, fallback);
    return this.lastValue;
  }
}

